// extracted by mini-css-extract-plugin
export default {"Wrapper":"Login_Wrapper__v6dMD","slideIn":"Login_slideIn__svUtF","DataBoxWrapper":"Login_DataBoxWrapper__w9gpa"};